import React, { useState, useEffect, useCallback } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';
import { getRegisterReport, getRegisterFilterOptions, closeRegister, getRegisterDetails } from '../../services/reportApi';
import { formatDateTime } from '../../utils/dateUtils';

const RegisterDetailsModalContent = ({ data }) => {
    const rd = data.register_details || {};
    const td = data.transaction_details || {};
    const pt = data.payment_types || {};
    const fmt = (v) => v || '--';
    const payRows = [
        { label: 'Cash in hand', sell: rd.cash_in_hand_formatted, expense: null },
        { label: 'Cash Payment', sell: rd.total_cash_formatted, expense: rd.total_cash_expense_formatted },
        { label: 'Cheque Payment', sell: rd.total_cheque_formatted, expense: rd.total_cheque_expense_formatted },
        { label: 'Card Payment', sell: rd.total_card_formatted, expense: rd.total_card_expense_formatted },
        { label: 'Bank Transfer', sell: rd.total_bank_transfer_formatted, expense: rd.total_bank_transfer_expense_formatted },
        { label: 'Advance Payment', sell: rd.total_advance_formatted, expense: rd.total_advance_expense_formatted },
        ...(pt.custom_pay_1 ? [{ label: pt.custom_pay_1, sell: rd.total_custom_pay_1_formatted, expense: rd.total_custom_pay_1_expense_formatted }] : []),
        ...(pt.custom_pay_2 ? [{ label: pt.custom_pay_2, sell: rd.total_custom_pay_2_formatted, expense: rd.total_custom_pay_2_expense_formatted }] : []),
        ...(pt.custom_pay_3 ? [{ label: pt.custom_pay_3, sell: rd.total_custom_pay_3_formatted, expense: rd.total_custom_pay_3_expense_formatted }] : []),
        ...(pt.custom_pay_4 ? [{ label: pt.custom_pay_4, sell: rd.total_custom_pay_4_formatted, expense: rd.total_custom_pay_4_expense_formatted }] : []),
        ...(pt.custom_pay_5 ? [{ label: pt.custom_pay_5, sell: rd.total_custom_pay_5_formatted, expense: rd.total_custom_pay_5_expense_formatted }] : []),
        ...(pt.custom_pay_6 ? [{ label: pt.custom_pay_6, sell: rd.total_custom_pay_6_formatted, expense: rd.total_custom_pay_6_expense_formatted }] : []),
        ...(pt.custom_pay_7 ? [{ label: pt.custom_pay_7, sell: rd.total_custom_pay_7_formatted, expense: rd.total_custom_pay_7_expense_formatted }] : []),
        { label: 'Other Payments', sell: rd.total_other_formatted, expense: rd.total_other_expense_formatted },
    ];
    return (
        <div style={{ padding: '1.5rem' }}>
            {/* Payment Methods */}
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
                <thead>
                    <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'left', color: '#1e293b' }}>Payment Method</th>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'right', color: '#1e293b' }}>Sell</th>
                        <th style={{ padding: '0.5rem 0.75rem', textAlign: 'right', color: '#1e293b' }}>Expense</th>
                    </tr>
                </thead>
                <tbody>
                    {payRows.map((r, i) => (
                        <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                            <td style={{ padding: '0.4rem 0.75rem', color: '#475569' }}>{r.label}:</td>
                            <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#475569' }}>{fmt(r.sell)}</td>
                            <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#475569' }}>{fmt(r.expense)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Summary Totals */}
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
                <tbody>
                    <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '0.4rem 0.75rem', color: '#475569', fontWeight: 600 }}>Total Sales:</td>
                        <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#1e293b' }}>{rd.total_sale_formatted}</td>
                    </tr>
                    <tr style={{ background: '#fef2f2', borderBottom: '1px solid #fecaca' }}>
                        <td style={{ padding: '0.4rem 0.75rem', color: '#991b1b', fontWeight: 600 }}>Total Refund:</td>
                        <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#991b1b' }}>
                            <b>{rd.total_refund_formatted}</b>
                            <div style={{ fontSize: '0.75rem', color: '#b91c1c', marginTop: '0.25rem' }}>
                                {rd.total_cash_refund > 0 && <div>Cash: {rd.total_cash_refund_formatted}</div>}
                                {rd.total_cheque_refund > 0 && <div>Cheque: {rd.total_cheque_refund_formatted}</div>}
                                {rd.total_card_refund > 0 && <div>Card: {rd.total_card_refund_formatted}</div>}
                                {rd.total_bank_transfer_refund > 0 && <div>Bank Transfer: {rd.total_bank_transfer_refund_formatted}</div>}
                                {rd.total_other_refund > 0 && <div>Other: {rd.total_other_refund_formatted}</div>}
                            </div>
                        </td>
                    </tr>
                    <tr style={{ background: '#f0fdf4', borderBottom: '1px solid #bbf7d0' }}>
                        <td style={{ padding: '0.4rem 0.75rem', color: '#166534', fontWeight: 600 }}>Total Payment:</td>
                        <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#166534' }}><b>{rd.total_cash_formatted}</b></td>
                    </tr>
                    <tr style={{ background: '#f0fdf4', borderBottom: '1px solid #bbf7d0' }}>
                        <td style={{ padding: '0.4rem 0.75rem', color: '#166534', fontWeight: 600 }}>Credit Sales:</td>
                        <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#166534' }}><b>{td.total_sales_formatted}</b></td>
                    </tr>
                    <tr style={{ background: '#f0fdf4', borderBottom: '1px solid #bbf7d0' }}>
                        <td style={{ padding: '0.4rem 0.75rem', color: '#166534', fontWeight: 600 }}>Total Sales:</td>
                        <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#166534' }}><b>{td.total_sales_formatted}</b></td>
                    </tr>
                    <tr style={{ background: '#fef2f2' }}>
                        <td style={{ padding: '0.4rem 0.75rem', color: '#991b1b', fontWeight: 600 }}>Total Expense:</td>
                        <td style={{ padding: '0.4rem 0.75rem', textAlign: 'right', color: '#991b1b' }}><b>{rd.total_expense_formatted}</b></td>
                    </tr>
                </tbody>
            </table>

            {/* Product Details */}
            {data.product_details && data.product_details.length > 0 && (
                <>
                    <h4 style={{ margin: '1.5rem 0 0.5rem', fontSize: '1rem', color: '#1e293b' }}>Product Sold Details</h4>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8125rem', marginBottom: '1rem' }}>
                        <thead><tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                            <th style={{ padding: '0.5rem', textAlign: 'left' }}>#</th>
                            <th style={{ padding: '0.5rem', textAlign: 'left' }}>SKU</th>
                            <th style={{ padding: '0.5rem', textAlign: 'left' }}>Product</th>
                            <th style={{ padding: '0.5rem', textAlign: 'right' }}>Qty</th>
                            <th style={{ padding: '0.5rem', textAlign: 'right' }}>Amount</th>
                        </tr></thead>
                        <tbody>
                            {data.product_details.map((p, i) => (
                                <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '0.4rem 0.5rem', color: '#475569' }}>{i + 1}.</td>
                                    <td style={{ padding: '0.4rem 0.5rem', color: '#475569' }}>{p.sku}</td>
                                    <td style={{ padding: '0.4rem 0.5rem', color: '#475569' }}>{p.product_name} {p.product_type === 'variable' ? `- ${p.product_variation_name} - ${p.variation_name}` : ''}</td>
                                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right', color: '#475569' }}>{p.total_quantity}</td>
                                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right', color: '#475569' }}>{p.total_amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            {/* By Brand */}
            {data.product_details_by_brand && data.product_details_by_brand.length > 0 && (
                <>
                    <h4 style={{ margin: '1.5rem 0 0.5rem', fontSize: '1rem', color: '#1e293b' }}>Product Sold Details (By Brand)</h4>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8125rem', marginBottom: '1rem' }}>
                        <thead><tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                            <th style={{ padding: '0.5rem', textAlign: 'left' }}>#</th>
                            <th style={{ padding: '0.5rem', textAlign: 'left' }}>Brand</th>
                            <th style={{ padding: '0.5rem', textAlign: 'right' }}>Qty</th>
                            <th style={{ padding: '0.5rem', textAlign: 'right' }}>Amount</th>
                        </tr></thead>
                        <tbody>
                            {data.product_details_by_brand.map((b, i) => (
                                <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '0.4rem 0.5rem', color: '#475569' }}>{i + 1}.</td>
                                    <td style={{ padding: '0.4rem 0.5rem', color: '#475569' }}>{b.brand_name || '--'}</td>
                                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right', color: '#475569' }}>{b.total_quantity}</td>
                                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right', color: '#475569' }}>{b.total_amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            {/* Denominations */}
            {rd.denominations && (
                <>
                    <h4 style={{ margin: '1.5rem 0 0.5rem', fontSize: '1rem', color: '#1e293b' }}>Cash Denominations</h4>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8125rem', marginBottom: '1rem' }}>
                        <thead><tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                            <th style={{ padding: '0.5rem', textAlign: 'right' }}>Denomination</th>
                            <th style={{ padding: '0.5rem', textAlign: 'center' }}>Count</th>
                            <th style={{ padding: '0.5rem', textAlign: 'left' }}>Subtotal</th>
                        </tr></thead>
                        <tbody>
                            {Object.entries(rd.denominations).map(([key, val], i) => (
                                <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'right', color: '#475569' }}>{key}</td>
                                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'center', color: '#475569' }}>{val || 0}</td>
                                    <td style={{ padding: '0.4rem 0.5rem', textAlign: 'left', color: '#475569' }}>{key * (val || 0)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            {/* User Info */}
            <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f8fafc', borderRadius: '6px', fontSize: '0.875rem', color: '#475569' }}>
                <div><b>User:</b> {rd.user_name}</div>
                <div><b>Email:</b> {rd.email}</div>
                <div><b>Business Location:</b> {rd.location_name}</div>
                {rd.closing_note && <div style={{ marginTop: '0.5rem' }}><b>Closing Note:</b> {rd.closing_note}</div>}
            </div>
        </div>
    );
};

const RegisterReport = () => {
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [showExportDropdown, setShowExportDropdown] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [lastPage, setLastPage] = useState(1);
    const [totals, setTotals] = useState(null);
    const [filterOptions, setFilterOptions] = useState({ locations: [], users: [], payment_types: {} });
    const [filters, setFilters] = useState({ start_date: '', end_date: '', location_id: '', user_id: '', status: '' });
    const [showFilters, setShowFilters] = useState(false);
    const [closingId, setClosingId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    const fetchData = useCallback(async (pg = 1, perPage = entriesPerPage) => {
        setLoading(true); setError(null);
        try {
            const res = await getRegisterReport({ ...filters, page: pg, per_page: perPage });
            if (res.success) {
                setData(res.data.data || []);
                setTotals(res.data.totals || null);
                setTotal(res.data.total || 0);
                setLastPage(res.data.last_page || 1);
                setPage(res.data.current_page || pg);
            }
        } catch (e) { setError(e.message); } finally { setLoading(false); }
    }, [filters, entriesPerPage]);

    useEffect(() => {
        fetchData(1, entriesPerPage);
        getRegisterFilterOptions().then(r => {
            if (r.success) setFilterOptions(prev => ({ ...prev, ...r.data }));
        }).catch(() => {});
    }, []);
    useEffect(() => { fetchData(1, entriesPerPage); }, [entriesPerPage]);

    const handleFilterApply = () => { fetchData(1, entriesPerPage); setShowFilters(false); };
    const handleFilterReset = () => setFilters({ start_date: '', end_date: '', location_id: '', user_id: '', status: '' });

    const filteredData = data.filter(r =>
        (r.cashier || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (r.location_name || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleClose = async (id) => {
        if (!window.confirm('Are you sure you want to close this register?')) return;
        try {
            setClosingId(id);
            const res = await closeRegister({ id });
            if (res.success) {
                fetchData(page, entriesPerPage);
            } else {
                setError(res.msg || 'Failed to close register');
            }
        } catch (e) { setError(e.message); }
        finally { setClosingId(null); }
    };

    const handleView = async (id) => {
        setShowModal(true);
        setModalLoading(true);
        setModalData(null);
        try {
            const res = await getRegisterDetails(id);
            if (res.success) {
                setModalData(res.data);
            } else {
                setError(res.msg || 'Failed to load register details');
            }
        } catch (e) { setError(e.message); }
        finally { setModalLoading(false); }
    };

    const paymentTypes = filterOptions.payment_types || {};
    const customLabels = [
        paymentTypes.custom_pay_1 || 'Custom Payment 1',
        paymentTypes.custom_pay_2 || 'Custom Payment 2',
        paymentTypes.custom_pay_3 || 'Custom Payment 3',
        paymentTypes.custom_pay_4 || 'Custom Payment 4',
        paymentTypes.custom_pay_5 || 'Custom Payment 5',
        paymentTypes.custom_pay_6 || 'Custom Payment 6',
        paymentTypes.custom_pay_7 || 'Custom Payment 7',
    ];

    const tableHeaders = [
        'Open Time', 'Close Time', 'Location', 'User',
        'Total Card Slips', 'Total Cheques', 'Total Cash',
        'Total Bank Transfer', 'Total Advance Payment',
        ...customLabels,
        'Other Payments', 'Total', 'Action'
    ];

    const handleExport = (format) => {
        const exportHeaders = [...tableHeaders.slice(0, -1)];
        const rows = filteredData.map(r => [
            r.created_at ? formatDateTime(r.created_at) : '',
            r.closed_at ? formatDateTime(r.closed_at) : '',
            r.location_name || '', r.cashier || '',
            r.total_card_payment_formatted || '',
            r.total_cheque_payment_formatted || '',
            r.total_cash_payment_formatted || '',
            r.total_bank_transfer_payment_formatted || '',
            r.total_advance_payment_formatted || '',
            r.total_custom_pay_1_formatted || '',
            r.total_custom_pay_2_formatted || '',
            r.total_custom_pay_3_formatted || '',
            r.total_custom_pay_4_formatted || '',
            r.total_custom_pay_5_formatted || '',
            r.total_custom_pay_6_formatted || '',
            r.total_custom_pay_7_formatted || '',
            r.total_other_payment_formatted || '',
            r.total_formatted || ''
        ]);
        const title = 'Register Report'; const filename = 'register_report';
        if (format === 'CSV') exportToCSV(exportHeaders, rows, filename);
        else if (format === 'Excel') exportToExcel(exportHeaders, rows, filename);
        else if (format === 'PDF') exportToPDF(title, exportHeaders, rows, filename);
        else if (format === 'Print') printPage();
        setShowExportDropdown(false);
    };

    const from = total === 0 ? 0 : (page - 1) * entriesPerPage + 1;
    const to = Math.min(page * entriesPerPage, total);
    const inputStyle = { padding: '0.35rem 0.6rem', border: '1px solid #e2e8f0', borderRadius: '5px', fontSize: '0.8rem', outline: 'none', background: '#fff' };
    const selStyle = { ...inputStyle, cursor: 'pointer' };

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Filters ── */}
            <div style={{ marginBottom: '0.75rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center' }}>
                <button onClick={() => setShowFilters(v => !v)} style={{ ...inputStyle, cursor: 'pointer', background: showFilters ? '#3b82f6' : '#fff', color: showFilters ? '#fff' : '#334155', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                    <i className="fa fa-filter" /> Filters
                </button>
                {showFilters && (<>
                    <input type="date" value={filters.start_date} onChange={e => setFilters(f => ({ ...f, start_date: e.target.value }))} style={inputStyle} />
                    <input type="date" value={filters.end_date} onChange={e => setFilters(f => ({ ...f, end_date: e.target.value }))} style={inputStyle} />
                    <select value={filters.status} onChange={e => setFilters(f => ({ ...f, status: e.target.value }))} style={selStyle}>
                        <option value="">All Status</option>
                        <option value="open">Open</option>
                        <option value="close">Close</option>
                    </select>
                    <select value={filters.location_id} onChange={e => setFilters(f => ({ ...f, location_id: e.target.value }))} style={selStyle}>
                        <option value="">All Locations</option>
                        {filterOptions.locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                    </select>
                    <select value={filters.user_id} onChange={e => setFilters(f => ({ ...f, user_id: e.target.value }))} style={selStyle}>
                        <option value="">All Users</option>
                        {filterOptions.users.map(u => <option key={u.id} value={u.id}>{u.name || `${u.first_name || ''} ${u.last_name || ''}`}</option>)}
                    </select>
                    <button onClick={handleFilterApply} style={{ ...inputStyle, background: '#3b82f6', color: '#fff', cursor: 'pointer', border: 'none' }}>Apply</button>
                    <button onClick={handleFilterReset} style={{ ...inputStyle, cursor: 'pointer' }}>Reset</button>
                </>)}
            </div>

            {/* ── Table Container ── */}
            <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>

                {/* Table controls */}
                <div className="table-controls" style={{ borderBottom: '1px solid #e2e8f0', padding: '1rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select">
                            <span>Show</span>
                            <select value={entriesPerPage} onChange={e => setEntriesPerPage(Number(e.target.value))}>
                                <option value={25}>25</option><option value={50}>50</option><option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>
                    <div className="table-controls-right">
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button className="export-btn" onClick={() => setShowExportDropdown(!showExportDropdown)} style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0', borderRadius: '6px', background: '#fff', cursor: 'pointer', fontSize: '0.85rem', color: '#334155' }}>
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                Export ▾
                            </button>
                            {showExportDropdown && (
                                <div className="export-dropdown-menu" style={{ position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 10, minWidth: '160px' }}>
                                    {[{ icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport('CSV') }, { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport('Excel') }, { icon: 'fa-print', label: 'Print', action: () => handleExport('Print') }, { icon: 'fa-file-pdf-o', label: 'Export PDF', action: () => handleExport('PDF') }].map((item, i) => (
                                        <button key={i} onClick={() => { if (item.action) item.action(); setShowExportDropdown(false); }} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: '100%', padding: '0.5rem 1rem', border: 'none', background: 'none', textAlign: 'left', cursor: 'pointer', fontSize: '0.8125rem', color: '#475569' }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />{item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                        <input type="text" placeholder="Search ..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{ padding: '0.4rem 0.75rem', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.8125rem', outline: 'none', width: '180px' }} />
                    </div>
                </div>

                {error && <div style={{ padding: '1rem', color: '#ef4444', fontSize: '0.875rem' }}>Error: {error}</div>}

                {/* Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                {tableHeaders.map(h => (
                                    <th key={h} style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', whiteSpace: 'nowrap' }}>{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={tableHeaders.length} style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>Loading...</td></tr>
                            ) : filteredData.length === 0 ? (
                                <tr><td colSpan={tableHeaders.length} style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>No data available in table</td></tr>
                            ) : filteredData.map((row, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.created_at ? formatDateTime(row.created_at) : ''}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.closed_at ? formatDateTime(row.closed_at) : ''}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.location_name}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569' }}>{row.cashier}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_card_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_cheque_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_cash_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_bank_transfer_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_advance_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_custom_pay_1_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_custom_pay_2_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_custom_pay_3_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_custom_pay_4_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_custom_pay_5_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_custom_pay_6_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_custom_pay_7_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#475569', whiteSpace: 'nowrap' }}>{row.total_other_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '500', whiteSpace: 'nowrap' }}>{row.total_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                        <button onClick={() => handleView(row.id)} style={{ padding: '0.25rem 0.75rem', background: '#fff', border: '1px solid #3b82f6', color: '#3b82f6', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '600', cursor: 'pointer', marginRight: '0.25rem' }}>View</button>
                                        {row.status !== 'close' && (
                                            <button onClick={() => handleClose(row.id)} disabled={closingId === row.id} style={{ padding: '0.25rem 0.75rem', background: '#fff', border: '1px solid #ef4444', color: '#ef4444', borderRadius: '4px', fontSize: '0.75rem', fontWeight: '600', cursor: 'pointer' }}>
                                                {closingId === row.id ? 'Closing...' : 'Close'}
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        {totals && (
                            <tfoot>
                                <tr style={{ background: '#f1f5f9', borderTop: '2px solid #e2e8f0', fontWeight: '700' }}>
                                    <td colSpan="4" style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', textAlign: 'right' }}>Total:</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_card_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_cheque_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_cash_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_bank_transfer_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_advance_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_custom_pay_1_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_custom_pay_2_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_custom_pay_3_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_custom_pay_4_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_custom_pay_5_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_custom_pay_6_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_custom_pay_7_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_other_payment_formatted}</td>
                                    <td style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', whiteSpace: 'nowrap' }}>{totals.total_formatted}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        )}
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid #e2e8f0' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem' }}>
                        {total > 0 ? `Showing ${from} to ${to} of ${total} entries` : 'No entries'}
                    </div>
                    <div className="pagination-controls">
                        <button className={`page-btn${page <= 1 ? ' disabled' : ''}`} onClick={() => { if (page > 1) fetchData(page - 1); }} disabled={page <= 1}>Previous</button>
                        {Array.from({ length: Math.min(lastPage, 5) }, (_, i) => { const pg = page <= 3 ? i + 1 : page - 2 + i; if (pg < 1 || pg > lastPage) return null; return <button key={pg} className={`page-btn${pg === page ? ' active' : ''}`} onClick={() => fetchData(pg)}>{pg}</button>; })}
                        <button className={`page-btn${page >= lastPage ? ' disabled' : ''}`} onClick={() => { if (page < lastPage) fetchData(page + 1); }} disabled={page >= lastPage}>Next</button>
                    </div>
                </div>
            </div>

            {/* ── Register Details Modal ── */}
            {showModal && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }} onClick={(e) => { if (e.target === e.currentTarget) setShowModal(false); }}>
                    <div style={{ background: '#fff', borderRadius: '10px', maxWidth: '900px', width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
                        {modalLoading ? (
                            <div style={{ padding: '3rem', textAlign: 'center', color: '#64748b' }}>Loading...</div>
                        ) : modalData ? (
                            <>
                                <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b' }}>
                                        Register Details ({modalData.register_details?.open_time ? formatDateTime(modalData.register_details.open_time) : ''} - {modalData.register_details?.closed_at ? formatDateTime(modalData.register_details.closed_at) : ''})
                                    </h3>
                                    <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', fontSize: '1.25rem', color: '#64748b', cursor: 'pointer' }}>&times;</button>
                                </div>
                                <RegisterDetailsModalContent data={modalData} />
                                <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid #e2e8f0', display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                                    <button onClick={() => window.print()} style={{ padding: '0.5rem 1rem', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '0.875rem', cursor: 'pointer' }}>Print</button>
                                    <button onClick={() => setShowModal(false)} style={{ padding: '0.5rem 1rem', background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '0.875rem', cursor: 'pointer' }}>Close</button>
                                </div>
                            </>
                        ) : (
                            <div style={{ padding: '3rem', textAlign: 'center', color: '#64748b' }}>No data</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default RegisterReport;
